import { DatePipe } from '@angular/common';
import { Injectable, Output } from '@angular/core';
import { TranslateService } from "@ngx-translate/core";
import { MessageService } from "primeng/api";
import { Observable } from 'rxjs/Observable';
import { publishReplay, refCount } from 'rxjs/operators';
import { ListMetadata } from '../../models/list-metadata.model';
import { PointTransferModel } from '../../models/loyalty-card.model';
import { ExternalMovements, Movement } from '../../models/loyalty-movement.model';
import { HttpClientService } from '../httpClient/httpclient.service';
@Injectable()
export class LoyaltyMovementService {

  private cache = new Map<string, Movement>();
  public baseUrl = '/koncentro-loyalty/movement';
  public baseManualMovementUrl = '/koncentro-api/kloy/insertManualMovement';
  private cachedFields: Observable<any>;


  constructor (
    private http: HttpClientService,
    private datePipe: DatePipe,
    private messageService: MessageService,
    private translate: TranslateService
  ) { }
  private _minChars: string;

  get minChars(): string {
  return this._minChars;
  }

  set minChars(value: string) {
  this._minChars = value;
  }


  get(movementId): Observable<Movement> {
    if (this.cache.has(movementId)) {
      return Observable.of(this.cache.get(movementId));
    }

    return this.http.get(this.baseUrl + '/' + movementId);

  }

  list(
    offset = null,
    limit = null,
    search?: Array<{ key: string, value: string }>,
    globalSearch?: string,
    sort?: string,
    sort_dir?: number): Observable <{data: Array<Movement>, metadata: ListMetadata}> {

    

    let params = HttpClientService.buildListParams(offset, limit, search, globalSearch, sort, sort_dir);
    /*if(params.get('card_no') === null && params.get('customerDescription')=== null && params.get('storeDescription')=== null && params.get('reasonDescription')=== null){
      this.messageService.add({severity: 'error', summary: this.translate.instant('common.warning'), detail:  this.translate.instant('movement.addFilterCard')});
      return;
    }*/
    const regex: RegExp = new RegExp('^[0-9]+$');
    let cardNo = params.get('card_no');
    let isValid = cardNo!==null && (regex.test(cardNo));

    if(params.get('card_no') === null ||
        ( isValid && !((cardNo.length +1) > Number(this._minChars)) )){
        this.messageService.add({severity: 'error', summary: this.translate.instant('common.warning'),
          detail: this.translate.instant('movement.addFilterCard', {minChars:this._minChars})});
        return;
    }

    if(!isValid){
      this.messageService.add({severity: 'error', summary: this.translate.instant('common.warning'),
        detail: this.translate.instant('movement.filterCardWarn')});
      return;
    }


    if ( search ) {
      for (const filter of search) {
        params.set(filter.key, filter.value);
      }
    }
    if ( offset !== null ) {
      params.set('offset', offset.toString());
    }
    if ( limit !== null ) {
      params.set('limit', limit.toString());
    }
    params.set('flg_manual', "1");
    console.log('***** SORT', sort, '***** PARAMS', params);
    // return this.http.getPaged(this.baseUrl + '/manual?' + params.toString());
    return this.http.getPaged(this.baseUrl + '?' + params.toString());
  }

  getTopMovementsByAccumulatorId(accumulatorId: number, customerHostId: number, cardNo: string): Observable <{data: Array<Movement>, metadata: ListMetadata}> {
    return this.getAllMovements(0, 10, {
      acm: accumulatorId,
      customerHostId,
      cardNo
    })
  }

  getAllMovementsFiltered(filters): Observable <{data: Array<any>, metadata: ListMetadata}> {
    let params = {};

    //sostituzione carta con cliente
    if (filters.customer_id) {
      params['customerId'] = filters.customer_id;
    }
    if (filters.date_start != null) {
      params['date_from'] = this.datePipe.transform(filters.date_start, 'yyyy-MM-dd');
    }
    if (filters.date_end != null) {
      params['date_to'] = this.datePipe.transform(filters.date_end, 'yyyy-MM-dd');
    }
    if (filters.reason != null) {
      const reasons = filters.reason.reduce((r1, r2) => r1.toString().concat(',').concat(r2.toString()));
      if (filters.exclude_reason == null || !filters.exclude_reason) {
        params['reasonIn'] = reasons;
      } else {
        params['reasonNotIn'] = reasons;
      }
    }
    if (filters.acm != null) {
      params['acm'] = filters.acm;
    }
    if (filters.dsn != null) {
      params['divisionSalesNetworkId'] = filters.dsn
    }
    if (filters.store != null) {
      const store = filters.store.reduce((s1, s2) => s1.toString().concat(',').concat(s2.toString()));
      params['storesId'] = store
    }
      // 💡 Aggiunta gestione `showExpiredAcm`
  if (filters.showExpiredAcm != null) {
    params['activeAcm'] = !filters.showExpiredAcm;
  }
      // Imposta il limite massimo per bypassare il default di 200
    params['limit'] = 99999;

    return this.getAllMovements(null, null, params)

  }
  //TODO: attenzione verificare se sostituire carta con cliente anche qui
  getKloyMovements(filters: any, companyCode: number): Observable <{data: any, metadata: ListMetadata}> {
    let params = {};
    if (filters.card) {
      params['cardNo'] = filters.card;
    }
    if (filters.date_start != null) {
      params['dtStart'] = this.datePipe.transform(filters.date_start, 'yyyy-MM-dd');
    }
    if (filters.date_end != null) {
      params['dtEnd'] = this.datePipe.transform(filters.date_end, 'yyyy-MM-dd');
    }

    if (filters.acm != null) {
      params['acmCode'] = filters.acm;
    }
     
  if (filters.showExpiredAcm != null) {
    params['activeAcm'] = !filters.showExpiredAcm;
  }
    return this.http.getPaged(`/koncentro-api/kloy/getMovements?companyCode=${companyCode}`, params);

  }
  getAllMovements(offset?: number, limit?: number, search?: any): Observable <{data: Array<Movement>, metadata: ListMetadata}> {
    let params = {};
    console.log('+++++ SEARCH', search);
    if (offset) {
      params['offset'] = offset;
    }
    if (limit) {
      params['limit'] = limit;
    }
    if (search) {
      for (const k in search) {
        params[k] = search[k];
      }
    }

    return this.http.getPaged(`${this.baseUrl}`, params)
  }


  update(movement: Movement): Observable<Movement> {
    return this.http.put(this.baseUrl + '/' + movement.id, movement).map(res => {
      this.cache.delete(movement.id);
      return res;
    });
  }

  create(movement: Movement): Observable<Movement> {
    return this.http.post(this.baseUrl + '/', movement);
  }

  insertManualMovement(movement: Movement, companyCode: number): Observable<any> {
    return this.http.post(`${this.baseManualMovementUrl}?companyCode=${companyCode}`, movement);
  }

  remove(movementId): Observable<Movement> {
    return this.http.delete(this.baseUrl + '/' + movementId).map(res => {
      this.cache.delete(movementId);
      return res;
    });
  }

  transferPoints(transfer: PointTransferModel) {
    return this.http.post(`${this.baseUrl}/pointTransfer`, transfer);
  }

  insertMovement(movement: ExternalMovements): Observable<Movement> {
    return this.http.postAdv(this.baseUrl + '/insertMovement', movement, true);
  }

  getFields() {
    if (!this.cachedFields) {
      this.cachedFields = this.http.get('/koncentro-loyalty/schema/MovementDto').pipe(
        publishReplay(1), // this tells Rx to cache the latest emitted
        refCount() // and this tells Rx to keep the Observable alive as long as there are any Subscribers
      )
    }
    return this.cachedFields;
  }

}



// WEBPACK FOOTER //
// ./src/app/services/loyalty/loyalty-movement.service.ts